import { FormBuilder, FormControl } from '@angular/forms';
import {
  CombinedDatepickerRangeModel,
  CombinedDatepickerRangeOutput,
  ListRange,
  SearchCriteriaBase,
} from '../../../../../../common/models';
import { ListQueryParam } from '../../../../../../common/constants/list-query-param.constant';
import { FailedMessageFilterName } from '../../constants';

export class FailedMessageFiltersModelBase {
  [FailedMessageFilterName.TransportReferences]: string[] = [];
  [FailedMessageFilterName.CarrierIds]: string[] = [];

  constructor(params?: FailedMessageFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessagesFilterModel extends SearchCriteriaBase {
  [ListQueryParam.TransactionDateTime]: CombinedDatepickerRangeOutput;
  [ListQueryParam.CarrierId]: string[];
  [ListQueryParam.TransportReferences]: string[];

  constructor(params?: FailedMessagesFilterModel | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessageFiltersDatepickerRangeModel extends FailedMessageFiltersModelBase {
  [FailedMessageFilterName.TransactionDateTime] = new CombinedDatepickerRangeModel();

  constructor(params?: FailedMessageFiltersDatepickerRangeModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessageFiltersDatepickerRangeOutput extends FailedMessageFiltersModelBase {
  [FailedMessageFilterName.TransactionDateTime] = new CombinedDatepickerRangeOutput();

  constructor(params?: FailedMessageFiltersDatepickerRangeOutput) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class FailedMessageFiltersForm {
  constructor(
    model: FailedMessageFiltersDatepickerRangeModel,
    fb: FormBuilder = new FormBuilder(),
    public transactionDateTime: FormControl<CombinedDatepickerRangeOutput> = fb.control<CombinedDatepickerRangeOutput>(
      new CombinedDatepickerRangeOutput(model.transactionDateTime),
      [],
    ),
    public transportReferences: FormControl<string[]> = fb.control<string[]>(model.transportReferences, []),
    public carrierIds: FormControl<string[]> = fb.control<string[]>(model.carrierIds, []),
  ) {}
}
